import { render, staticRenderFns } from "./ProgramManagementMemberForm.vue?vue&type=template&id=537dd6b5&"
import script from "./ProgramManagementMemberForm.vue?vue&type=script&lang=js&"
export * from "./ProgramManagementMemberForm.vue?vue&type=script&lang=js&"
import style0 from "./ProgramManagementMemberForm.vue?vue&type=style&index=0&id=537dd6b5&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports